import React from "react";

const VideoQuestion = ({ question, answer, onAnswer }) => {
  return (
    <div className="space-y-4">
      <h2 className="font-bold text-lg text-gray-800">{question.text}</h2>
      <video controls className="w-full rounded-md" src={question.videoUrl} />
      <div className="space-y-2">
        {question.options.map((opt, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              type="radio"
              name={question._id}
              checked={answer === i}
              onChange={() => onAnswer(i)}
            />
            <label>{opt}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoQuestion;
